var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"50%","margin":"auto","display":"flex"}},[_c('div',{staticClass:"video-wrapper"},[_c('video',{ref:"videoPlayer",staticClass:"embed video-js vjs-theme-sea"})])])}
var staticRenderFns = []

export { render, staticRenderFns }